const types = {
  loadItems: 'loadItems',
  setIsLoading: 'setIsLoading',
  setSearch: 'setSearch',
  clearSearch: 'clearSerach',
  setSorts: 'setSorts',
  loadItem: 'loadItem'
}

/**
 * Шаблон Vuex хранилища.
 * @deprecated
 */
export default (api) => {
  let request = null
  return {
    namespaced: true,

    /**
     * Vuex state
     * @property {array} items Массив хранимых объектов, например: все автомобили, все водители и т.д.
     * @property {int} pageSize Размер страницы
     * @property {int} pageCount Количество страниц
     * @property {int} totalCount Всего элементов на всех страницах
     * @property {object} searches {key => value} значения для поиска с использованием фильтра
     * @property {boolean} isLoading Значение указывает загружаются ли сейчас объекты
     * @property {array} expand Отражает какими полями будет дополнен ответ сервера
     */
    state: {
      items: [],
      page: 1,
      pageSize: 10000000,
      pageCount: null,
      totalCount: null,
      searches: {},
      sort: [],
      isLoading: false,
      expandAllItems: [],
      expandSingleItem: []
    },

    mutations: {
      /**
       * @deprecated
       */
      [types.loadItems] (state, {
        items,
        page,
        pageCount,
        pageSize,
        totalCount
      }) {
        state.items = items
        state.page = page
        state.pageCount = pageCount
        state.pageSize = pageSize
        state.totalCount = totalCount
      },
      /**
       * @deprecated
       */
      [types.loadItem] (state, { item }) {
        const updatingItem = state.items.find(el => el.id === item.id)

        if (!updatingItem) {
          state.items.push(item)
          return
        }

        Object.assign(updatingItem, item)
      },
      /**
       * @deprecated
       */
      [types.setSearch] (state, { key, value }) {
        state.searches[key] = value
      },
      /**
       * @deprecated
       */
      [types.setIsLoading] (state, value) {
        state.isLoading = value
      },
      /**
       * @deprecated
       */
      [types.setSorts] (state, sorts) {
        state.sort = sorts.map(sort => sort.values[sort.index])
      }
    },
    actions: {
      /**
       * @deprecated
       */
      loadItems ({ state, commit, dispatch }, params) {
        if (state.isLoading) {
          dispatch('abortLoading')
        }
        let page = state.page
        let pageSize = state.pageSize
        let searches = state.searches
        let expand = state.expandAllItems
        let sort = state.sort
        if (params && params.page) {
          page = params.page
        }
        if (params && params.pageSize) {
          pageSize = params.pageSize
        }
        if (params && params.searches) {
          searches = params.searches
        }
        if (params && params.expand) {
          expand = params.expand
        }
        if (params && params.sort) {
          sort = params.sort
        }

        request = api.getItems({
          page,
          pageSize,
          searches,
          expand,
          sort
        })
        commit(types.setIsLoading, true)
        return request.promise
          .then(params => {
            request = null
            commit(types.setIsLoading, false)
            commit(types.loadItems, params)
            return params.items
          }, () => commit(types.setIsLoading, false))
      },
      /**
       * @deprecated
       */
      loadItem ({ state, commit, dispatch }, params) {
        if (state.isLoading) {
          dispatch('abortLoading')
        }
        let expand = state.expandSingleItem
        if (params && params.expand) {
          expand = params.expand
        }
        request = api.getItemPromise({ id: params.id, expand: expand })
        commit(types.setIsLoading, true)
        return request.promise
          .then(params => {
            request = null
            commit(types.setIsLoading, false)
            commit(types.loadItem, { item: params.items })
            return params.items
          })
      },
      /**
       * @deprecated
       */
      abortLoading ({ commit }) {
        commit(types.setIsLoading, false)
        if (request) {
          request.abort()
          request = null
        }
      },
      /**
       * @deprecated
       */
      setSearch ({ commit }, { key, value }) {
        commit(types.setSearch, { key, value })
      },
      /**
       * @deprecated
       */
      setSorts ({ commit }, sorts) {
        commit(types.setSorts, sorts)
      },
      /**
       * @deprecated
       */
      clearSearch ({ commit }) {
        commit(types.clearSearch)
      }
    },
    types
  }
}
